import type { JsonStorageKind } from './runtimeConfigJsonEditorUtils'

export type RuntimeJsonEditorKind = 'generic' | 'gasThresholds' | 'walletThresholds' | 'tokenPrice'

export type RuntimeJsonDescriptor = {
  key: string
  storageKind: JsonStorageKind
  editor: RuntimeJsonEditorKind
  readonlyPaths?: readonly string[]
}

const descriptors: readonly RuntimeJsonDescriptor[] = [
  { key: 'CACHE_CONFIG_JSON', storageKind: 'object', editor: 'generic' },
  { key: 'GAS_THRESHOLD_DEFAULTS', storageKind: 'json-string', editor: 'gasThresholds' },
  { key: 'MAIL_TEMPLATE_IDS', storageKind: 'json-string', editor: 'generic' },
  { key: 'TESTNET_ORDER_CREATION_SNAPSHOT_DEFAULTS', storageKind: 'json-string', editor: 'generic' },
  { key: 'PLATFORM_WALLET_BALANCE_THRESHOLDS', storageKind: 'object', editor: 'walletThresholds' },
  { key: 'TOKEN_PRICE_CONFIG_JSON', storageKind: 'object', editor: 'tokenPrice' },
  { key: 'MERCHANT_SUBSCRIPTIONS', storageKind: 'object', editor: 'generic' },
  {
    key: 'ORDER_DOCUMENT_RETENTION_POLICY',
    storageKind: 'object',
    editor: 'generic',
    readonlyPaths: ['schemaVersion', 'mode', 'policyVersion'],
  },
]

export const getRuntimeJsonDescriptor = (key: string): RuntimeJsonDescriptor => {
  return descriptors.find(item => item.key === key)
    ?? { key, storageKind: 'object', editor: 'generic' }
}

export const runtimeJsonDescriptors = descriptors
